import { render, staticRenderFns } from "./MessagePreview2.vue?vue&type=template&id=9d63d254&scoped=true&"
import script from "./MessagePreview2.vue?vue&type=script&lang=js&"
export * from "./MessagePreview2.vue?vue&type=script&lang=js&"
import style0 from "./MessagePreview2.vue?vue&type=style&index=0&id=9d63d254&prod&lang=scss&scoped=true&"
import style1 from "./MessagePreview2.vue?vue&type=style&index=1&id=9d63d254&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d63d254",
  null
  
)

export default component.exports